class wishlistIcon extends HTMLElement {
  constructor() {
    super();
    this.productId = Number(this.getAttribute('data-product-id'));
    this.productHandle = this.getAttribute('data-product-handle');
    this.variantId = Number(this.getAttribute('data-variant-id'));
    this.addEventListener('click', this.onWishlistClick.bind(this));
  }

  connectedCallback() {
    this.updateIconState();
  }

  isInWishlist() {
    return window.wishlistItems.some((item) => item.variant_id === this.variantId);
  }

  updateIconState() {
    if (this.isInWishlist()) {
      this.classList.add('is-active');
    } else {
      this.classList.remove('is-active');
    }
  }

  onWishlistClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const wasInWishlist = this.isInWishlist();

    if (wasInWishlist) {
      window.wishlistItems = window.wishlistItems.filter(
        (item) => item.variant_id !== this.variantId
      );
    } else {
      window.wishlistItems.push({
        product_id: this.productId,
        product_handle: this.productHandle,
        variant_id: this.variantId,
      });
    }

    localStorage.setItem('wishlist-items', JSON.stringify(window.wishlistItems));
    this.updateIconState();

    document.dispatchEvent(
      new CustomEvent('wishlist:changed', {
        detail: {
          action: wasInWishlist ? 'remove' : 'add',
          variantId: this.variantId,
          productHandle: this.productHandle,
        },
      })
    );
  }
}

customElements.define('wishlist-icon', wishlistIcon);

class WishlistShare extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.wishlist-share__icon') || this.querySelector('.wishlist-share__btn');
    this.dropdown = this.querySelector('.wishlist-share__dropdown');
    this.shareUrl = this.getAttribute('data-share-url') || window.location.href;
    this.shareTitle = this.getAttribute('data-share-title') || '';
  }

  connectedCallback() {
    if (this.trigger) {
      this.trigger.addEventListener('click', this.onToggle.bind(this));
    }
    this.dropdown.querySelectorAll('.wishlist-share__option').forEach((btn) => {
      btn.addEventListener('click', this.onShare.bind(this));
    });
    this.outsideClickHandler = this.handleOutsideClick.bind(this);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.outsideClickHandler);
  }

  onToggle(event) {
    event.preventDefault();
    event.stopPropagation();

    if (navigator.share && 'canShare' in navigator) {
      navigator.share({ url: this.shareUrl, title: this.shareTitle }).catch(() => {});
      return;
    }

    const isOpen = !this.dropdown.hidden;
    this.closeAllDropdowns();
    if (!isOpen) {
      this.dropdown.hidden = false;
      document.addEventListener('click', this.outsideClickHandler);
    }
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.dropdown.hidden = true;
      document.removeEventListener('click', this.outsideClickHandler);
    }
  }

  closeAllDropdowns() {
    document.querySelectorAll('.wishlist-share__dropdown').forEach((d) => {
      d.hidden = true;
    });
  }

  onShare(event) {
    event.preventDefault();
    event.stopPropagation();
    const channel = event.currentTarget.getAttribute('data-channel');
    const url = encodeURIComponent(this.shareUrl);
    const title = encodeURIComponent(this.shareTitle);

    switch (channel) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${title}%20${url}`, '_blank');
        break;
      case 'email':
        window.location.href = `mailto:?subject=${title}&body=${title}%20${url}`;
        break;
      case 'x':
        window.open(`https://x.com/intent/tweet?url=${url}&text=${title}`, '_blank');
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
        break;
      case 'copy':
        navigator.clipboard.writeText(this.shareUrl).then(() => {
          const copyText = event.currentTarget.querySelector('.wishlist-share__copy-text');
          if (copyText) {
            copyText.textContent = 'Copied!';
            setTimeout(() => { copyText.textContent = 'Copy Link'; }, 2000);
          }
        });
        break;
    }

    if (channel !== 'copy') {
      this.dropdown.hidden = true;
    }
  }
}

customElements.define('wishlist-share', WishlistShare);
